import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HaccpFoodPreparation = lazy(
  () => import("@/pages/haccp/food-preparation/HaccpFoodPreparation"),
);
const HaccpFoodPreparationLayout = lazy(
  () => import("@/pages/haccp/food-preparation/HaccpFoodPreparationLayout"),
);
const MonthView = lazy(
  () => import("@/pages/haccp/food-preparation/components/month/MonthView"),
);
const DayView = lazy(
  () => import("@/pages/haccp/food-preparation/components/day/DayView"),
);

export const foodPreparationRoutes: RouteObject[] = [
  {
    path: "/haccp/food-preparation",
    element: <HaccpFoodPreparation />,
    children: [
      {
        path: "domain/:domainId",
        element: <HaccpFoodPreparationLayout />,
        children: [
          {
            path: "site/:siteId/day/:date",
            element: <DayView />,
          },
          {
            path: "month/:date",
            element: <MonthView />,
          },
        ],
      },
    ],
  },
];
